import { Core } from "@faire/design-tokens";
import { trackEventOnClick } from "@faire/web/common/trackEvent";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { EmbeddedLink } from "@faire/web/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";

export interface IProps {
  loginUrl?: string;
  eventPath: string;
}

export const SignIn: React.FC<IProps> = ({ loginUrl }) => (
  <>
    <Typography color={Core.text.subdued}>
      <StrictLocalMsg defaultMessage="Already shopping on Faire?" />
    </Typography>
    <Spacer size="1x" />
    <Typography>
      <EmbeddedLink
        color={Core.text.subdued}
        linkTo={loginUrl}
        replace
        onClick={trackEventOnClick("elevate-sign-up/landing-page/click/log-in")}
      >
        <StrictLocalMsg defaultMessage="Sign In" />
      </EmbeddedLink>
    </Typography>
  </>
);
